import { api, catchHandler } from "../../helpers/axios";
import server from "../../config/server";
// import { objToUrlParams } from "../../helpers/utils";

export async function sendContactData(data) {
  return (await api())
    .post(server.API_CONTACT_US,data)
    .then(res => res.data)
    .catch(catchHandler);
}